import { render } from "./LessonCatsTopic4.vue?vue&type=template&id=085a36d4"
import script from "./LessonCatsTopic4.vue?vue&type=script&lang=js"
export * from "./LessonCatsTopic4.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__